<div class="w-100">
    <div class="card w-100">
        <div class="card-header d-flex justify-content-between align-items-end">
            <span class="title mb-0">
                Mis Datos
            </span>

            <button (click)="onEdit = true;" class="btn btn-lg" style="margin:0; padding:0; border:0;">
                <i class="fa fa-edit p-2" *ngIf="!onEdit" style="margin-right:0"></i>
            </button>

            <button class="btn btn-info btn-sm p-2 m-1" *ngIf="onEdit" (click)="saveProfile()">
                <span style="font-weight: 600">Guardar Cambios</span>
            </button>
        </div>
        <div class="card-body">
            <div class="container-fluid" *ngIf="currentUser?.roles !== 'user'">
                <div class="section-info">
                    <label class="title-label">
                        Área o Dirección
                    </label>
                    <label class="data-label" *ngIf="!onEdit">
                        {{ profile?.Area }}
                    </label>
                    <input type="text" class="data-field" *ngIf="onEdit" [(ngModel)]="profile.Area">
                </div>
            </div>
        </div>

        <!-- Firma digital (solo admin) -->
        <ng-container *ngIf="currentUser?.roles == 'admin'">
            <div class="card-header">
                <div class="subtitle-section">
                    <span class="subtitle">Firma digital</span>
                </div>
            </div>
            <div class="card-body" style="padding: 20px 10px">
                <div class="container-fluid">
                    <table class="table table-mv table-danger-mv table-borderless">
                        <thead>
                            <tr class="w-100">
                                <th style="width:90%; border-bottom: 0"></th>
                                <th style="width:10%; border-bottom: 0">
                                    <span *ngIf="!isCerLoaded || !isKeyLoaded" class="text-danger">Agregar</span>
                                    <span *ngIf="isCerLoaded && isKeyLoaded" class="text-primary">Reemplazar</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="w-100 certificado">
                                <td style="width:90%" [ngClass]="{ 'loaded': isCerLoaded, 'notloaded': !isCerLoaded }">
                                    <div class="d-flex justify-content-between">
                                        <div class="bd-highlight">
                                            <span [ngClass]="{ 'text-danger': !isCerLoaded, 'text-secondary': isCerLoaded }">Certificado (.cer)</span>
                                        </div>
                                        <div class="bd-highlight">
                                            <div *ngIf="!isCerLoaded">
                                                <button class="btn-static text-uppercase text-danger text-center" style="font-weight:bold" (click)="fileCerInput.click()">Sin Agregar</button>
                                            </div>
                                            <div *ngIf="isCerLoaded">
                                                <ng-container *ngIf="fechaUltimaVez.cer == null else ActualizadoDesde">
                                                    <span class="text-secondary">Actualizado ahora.</span>
                                                </ng-container>
                                                <ng-template #ActualizadoDesde>
                                                    <span class="text-secondary">Actualizado {{ fechaUltimaVez.cer }}.</span>
                                                </ng-template>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td style="width:10%" class="text-center" [ngClass]="{ 'loaded': isCerLoaded, 'notloaded': !isCerLoaded }">
                                    <button class="btn-static text-center" [ngClass]="{ 'text-danger': !isCerLoaded, 'text-primary': isCerLoaded }" style="font-weight:bold" (click)="fileCerInput.click()" id="btnLoadCer" disabled>
                                        <i class="fa fa-plus-square" aria-hidden="true" *ngIf="!isCerLoaded"></i>
                                        <i class="fa fa-refresh" aria-hidden="true" *ngIf="isCerLoaded"></i>
                                    </button>
                                    <span class="spinner-border cargandoFiel" role="status" aria-hidden="true" style="position:absolute;height:0.83rem;width:0.83rem;color:#666666;"></span>
                                    <input type="file" #fileCerInput class="d-none" accept="application/x-x509-ca-cert" (change)="isCerLoaded ? uploadCerFile($event, false) : uploadCerFile($event)">
                                </td>
                            </tr>
                            <tr class="w-100 clave-privada">
                                <td style="width:90%" [ngClass]="{ 'loaded': isKeyLoaded, 'notloaded': !isKeyLoaded }">
                                    <div class="d-flex justify-content-between">
                                        <div class="bd-highlight">
                                            <span [ngClass]="{ 'text-danger': !isKeyLoaded, 'text-secondary': isKeyLoaded }">Clave privada (.key)</span>
                                        </div>
                                        <div class="bd-highlight text-danger">
                                            <div *ngIf="!isKeyLoaded">
                                                <form>
                                                    <button type="submit" class="btn-static text-uppercase text-danger text-center" style="font-weight:bold">Sin Agregar</button>
                                                </form>
                                            </div>
                                            <div *ngIf="isKeyLoaded">
                                                <ng-container *ngIf="fechaUltimaVez.key == null else ActualizadoDesde_2">
                                                    <span class="text-secondary">Actualizado ahora.</span>
                                                </ng-container>
                                                <ng-template #ActualizadoDesde_2>
                                                    <span class="text-secondary">Actualizado {{ fechaUltimaVez.key }}.</span>
                                                </ng-template>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td style="width:10%" class="text-center" [ngClass]="{ 'loaded': isKeyLoaded, 'notloaded': !isKeyLoaded }">
                                    <button class="btn-static text-danger" [ngClass]="{ 'text-danger': !isKeyLoaded, 'text-primary': isKeyLoaded }" style="font-weight:bold" (click)="fileKeyInput.click()" id="btnLoadKey" disabled>
                                        <i class="fa fa-plus-square" aria-hidden="true" *ngIf="!isKeyLoaded"></i>
                                        <i class="fa fa-refresh" aria-hidden="true" *ngIf="isKeyLoaded"></i>
                                    </button>
                                    <span class="spinner-border cargandoFiel" role="status" aria-hidden="true" style="position:absolute;height:0.83rem;width:0.83rem;color:#666666;"></span>
                                    <input type="file" #fileKeyInput class="d-none" accept=".key" (change)="isKeyLoaded ? uploadKeyFile($event, false) : uploadKeyFile($event)" required>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </ng-container>

        <!-- ── Sección: Generales ─────────────────────────────────────────── -->
        <div class="card-header">
            <div class="subtitle-section">
                <span class="subtitle">Generales</span>
            </div>
        </div>
        <div class="card-body">
            <div class="container-fluid">

                <!-- Nombre -->
                <div class="row">
                    <div class="col-12 col-md-6">
                        <div class="section-info">
                            <label class="title-label">
                                Nombre(s) <span *ngIf="onEdit" class="text-danger">*</span>
                            </label>
                            <label class="data-label" *ngIf="!onEdit">
                                {{ profile?.User?.firstName }}
                            </label>
                            <input type="text" class="data-field" *ngIf="onEdit" [(ngModel)]="profile.User.firstName">
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="section-info">
                            <label class="title-label">
                                Apellido paterno <span *ngIf="onEdit" class="text-danger">*</span>
                            </label>
                            <label class="data-label" *ngIf="!onEdit">
                                {{ dadName || '-' }}
                            </label>
                            <input type="text" class="data-field" *ngIf="onEdit" [(ngModel)]="dadName" placeholder="Apellido paterno">
                        </div>
                    </div>
                </div>

                <!-- Apellido materno | Teléfono celular -->
                <div class="row">
                    <div class="col-12 col-md-6">
                        <div class="section-info">
                            <label class="title-label">
                                Apellido materno
                            </label>
                            <label class="data-label" *ngIf="!onEdit">
                                {{ momName || '-' }}
                            </label>
                            <input type="text" class="data-field" *ngIf="onEdit" [(ngModel)]="momName" placeholder="Apellido materno">
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="section-info">
                            <label class="title-label">
                                Teléfono celular <span *ngIf="onEdit" class="text-danger">*</span>
                            </label>
                            <label class="data-label" *ngIf="!onEdit">
                                {{ profile?.User?.phoneNumber || '-' }}
                            </label>
                            <input type="text" class="data-field" *ngIf="onEdit" [(ngModel)]="profile.User.phoneNumber">
                        </div>
                    </div>
                </div>

                <!-- Correo electrónico | Fecha de nacimiento -->
                <div class="row">
                    <div class="col-12 col-md-6">
                        <div class="section-info">
                            <label class="title-label">Correo electrónico</label>
                            <label class="data-label" *ngIf="!onEdit">
                                {{ profile?.User?.email || '-' }}
                            </label>
                            <input type="text" disabled class="data-field" *ngIf="onEdit" [(ngModel)]="profile.User.email">
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="section-info">
                            <label class="title-label">
                                Fecha de nacimiento <span *ngIf="onEdit" class="text-danger">*</span>
                            </label>
                            <label class="data-label" *ngIf="!onEdit">
                                {{ profile?.User?.birthday ? (profile?.User?.birthday | date:'dd/MM/yyyy') : '-' }}
                            </label>
                            <input type="date" class="data-field" *ngIf="onEdit" [(ngModel)]="profile.User.birthday">
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <!-- ── Sección: Domicilio ─────────────────────────────────────────── -->
        <div class="card-header">
            <div class="subtitle-section">
                <span class="subtitle">Domicilio</span>
            </div>
        </div>
        <div class="card-body">
            <div class="container-fluid">

                <!-- Calle | Número exterior -->
                <div class="row">
                    <div class="col-12 col-md-6">
                        <div class="section-info">
                            <label class="title-label">
                                Calle <span *ngIf="onEdit" class="text-danger">*</span>
                            </label>
                            <label class="data-label" *ngIf="!onEdit">{{ address?.Street || '-' }}</label>
                            <input type="text" class="data-field" *ngIf="onEdit" [(ngModel)]="address.Street">
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="section-info">
                            <label class="title-label">
                                Número exterior <span *ngIf="onEdit" class="text-danger">*</span>
                            </label>
                            <label class="data-label" *ngIf="!onEdit">{{ address?.ExtNumber || '-' }}</label>
                            <input type="text" class="data-field" *ngIf="onEdit" [(ngModel)]="address.ExtNumber">
                        </div>
                    </div>
                </div>

                <!-- Número interior | Código postal -->
                <div class="row">
                    <div class="col-12 col-md-6">
                        <div class="section-info">
                            <label class="title-label">Número interior</label>
                            <label class="data-label" *ngIf="!onEdit">{{ address?.IntNumber || '-' }}</label>
                            <input type="text" class="data-field" *ngIf="onEdit" [(ngModel)]="address.IntNumber">
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="section-info">
                            <label class="title-label">
                                Código postal <span *ngIf="onEdit" class="text-danger">*</span>
                            </label>
                            <label class="data-label" *ngIf="!onEdit">{{ address?.ZipCode || '-' }}</label>
                            <input type="text" class="data-field" *ngIf="onEdit" [(ngModel)]="address.ZipCode">
                        </div>
                    </div>
                </div>

                <!-- Colonia | Municipio -->
                <div class="row">
                    <div class="col-12 col-md-6">
                        <div class="section-info">
                            <label class="title-label">
                                Colonia <span *ngIf="onEdit" class="text-danger">*</span>
                            </label>
                            <label class="data-label" *ngIf="!onEdit">{{ address?.Neighborhood || '-' }}</label>
                            <input type="text" class="data-field" *ngIf="onEdit" [(ngModel)]="address.Neighborhood">
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="section-info">
                            <label class="title-label">
                                Municipio <span *ngIf="onEdit" class="text-danger">*</span>
                            </label>
                            <label class="data-label" *ngIf="!onEdit">{{ address?.City || '-' }}</label>
                            <input type="text" class="data-field" *ngIf="onEdit" [(ngModel)]="address.City">
                        </div>
                    </div>
                </div>

                <!-- Estado -->
                <div class="row">
                    <div class="col-12 col-md-6">
                        <div class="section-info">
                            <label class="title-label">
                                Estado <span *ngIf="onEdit" class="text-danger">*</span>
                            </label>
                            <label class="data-label" *ngIf="!onEdit">{{ address?.State || '-' }}</label>
                            <input type="text" class="data-field" *ngIf="onEdit" [(ngModel)]="address.State">
                        </div>
                    </div>
                    <div class="col-12 col-md-6 d-flex align-items-end pb-2" *ngIf="onEdit">
                        <small class="text-muted"><span class="text-danger">*</span> Campos obligatorios</small>
                    </div>
                </div>

            </div>
        </div>
        <div class="card-footer"></div>
    </div>
</div>

